import AddressRecord from "onnit-ui/lib/@types/interfaces/address/AddressRecord";
import CreateUpdateAddressResponse from "onnit-ui/lib/@types/interfaces/address/CreateUpdateAddressResponse";
import CreateUpdateAddressCommand from "onnit-ui/lib/@types/interfaces/address/CreateUpdateAddressCommand";
import HttpUtil from "../utils/HttpUtil";
import AddressClient from "../clients/AddressClient";
import Action from "../interfaces/Action";
import ActionTypeEnum from "../enums/ActionTypeEnum";
import ThunkDispatch from "../interfaces/ThunkDispatch";
import ThunkAction from "../interfaces/ThunkAction";

const addressClient = new AddressClient();

// ------------------------- [ Action Creators ] -------------------------

const setAddresses = (addresses: AddressRecord[]): Action => ({
    type: ActionTypeEnum.ADDRESS_SET,
    addresses,
});

const addAddress = (address: AddressRecord): Action => ({
    type: ActionTypeEnum.ADDRESS_ADD,
    address,
});

const editAddress = (address: AddressRecord): Action => ({
    type: ActionTypeEnum.ADDRESS_UPDATE,
    address,
});

// ------------------------- [ Thunks ] -------------------------

export const loadAddresses = (customerId: number): ThunkAction<Promise<AddressRecord[]>> => async (dispatch: ThunkDispatch) => {
    try {
        const response = await addressClient.listAddresses(customerId);
        dispatch(setAddresses(response.data));

        return response.data;
    } catch (error) {
        const errorMessage = `Failed to load addresses for customer ID ${customerId}.`;
        HttpUtil.logErroneousRequest(errorMessage, error);

        throw error;
    }
};

export const createAddress = (config: CreateUpdateAddressCommand): ThunkAction<Promise<CreateUpdateAddressResponse>> => async (dispatch: ThunkDispatch) => {
    try {
        const response = await addressClient.createAddress(config);
        dispatch(addAddress(response.data));

        return response.data;
    } catch (error) {
        HttpUtil.logErroneousRequest("Failed to create address.", error);

        throw error;
    }
};

export const updateAddress = (address: AddressRecord): ThunkAction<Promise<CreateUpdateAddressResponse>> => async (dispatch: ThunkDispatch) => {
    try {
        const response = await addressClient.updateAddress(address);
        dispatch(editAddress(response.data));

        return response.data;
    } catch (error) {
        HttpUtil.logErroneousRequest("Failed to update address.", error);

        throw error;
    }
};
